import {
    ChangeDetectionStrategy,
    Component,
    OnInit,
    ViewChild,
} from '@angular/core';
import { AppStateFacade } from '@app-state';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import {
    IMLSkill,
    MLSkillStatus,
    ModalResultType,
} from '@models';
import { MLSkillsIOParametersComponent } from '@pages/ml/mlskills/subviews/mlskills-io-parameters';
import {
    MLPackagesService,
    MLPackageVersionsService,
    MLSkillsService,
} from '@services';

import {
    BehaviorSubject,
    Observable,
} from 'rxjs';

@Component({
    templateUrl: './mlskills-versions.modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        MLSkillsService,
        MLPackagesService,
        MLPackageVersionsService,
    ],
})
export class MLSkillVersionsModalComponent
    extends UiModalComponent<IMLSkill>
    implements OnInit {

    public loading$ = new BehaviorSubject(false);
    public isMLSkillEditAllowed!: Observable<boolean>;

    @ViewChild(MLSkillsIOParametersComponent, { static: true })
    public io!: MLSkillsIOParametersComponent;

    ngOnInit() {
        const appState = this._injector.get<AppStateFacade>(AppStateFacade);
        this.isMLSkillEditAllowed = appState.user.permissions.isGranted('MLSkills.Edit');
    }

    public onClose() {
        const closeResult =
            this.context.data.status === MLSkillStatus.Updating ?
                {
                    type: ModalResultType.Update,
                    data: this.context.data,
                } :
                undefined;
        this._dialogRef.close(closeResult);
    }

    public onUpdate(skillList: IMLSkill[]) {
        [this.context.data] = skillList;
    }
}
